/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Credential_RemoveInputs */

const vi_einvoice_credential_remove = /** @type {(inputs: Einvoice_Credential_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gỡ tài khoản`)
};

/**

* @param {Einvoice_Credential_RemoveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_remove = /** @type {((inputs?: Einvoice_Credential_RemoveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_RemoveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_remove(inputs)
});